import { useQuery } from '@apollo/react-hooks';
import React from 'react';
import { RETRIEVE_BULK_PRODUCT_PREMIUM_PROJECTIONS } from '../graphql';
const useBulkProductPremiumProjections = ({
  products,
  ...otherFactor
}, options) => {
  const stringifiedProducts = React.useMemo(() => JSON.stringify(products), [products]);
  const list = useQuery(RETRIEVE_BULK_PRODUCT_PREMIUM_PROJECTIONS, {
    ...options,
    variables: {
      ...(options === null || options === void 0 ? void 0 : options.variables),
      ...otherFactor,
      products: stringifiedProducts
    },
    skip: (options === null || options === void 0 ? void 0 : options.skip) || !products.length
  });
  const projections = React.useMemo(() => {
    if (!list.data) {
      return [];
    }
    return list.data.productPremiumProjections;
  }, [list.data]);
  return [projections, list];
};
export default useBulkProductPremiumProjections;